import React from 'react';

const {
  Provider: GithubServiceProvider,
  Consumer: GithubServiceConsumer
} = React.createContext();

export { GithubServiceProvider, GithubServiceConsumer };
